import { useEffect, useState } from "react";
import { Card } from "../../ui/card";

export default function FormSummary({ totalPoints }) {
  let [lessPoints, setLessPoints] = useState(true);
  useEffect(() => {
    if (totalPoints < 65) {
      setLessPoints(true);
    } else {
      setLessPoints(false);
    }
  }, [totalPoints]);

  return (
    <section aria-labelledby="form-summary-title">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 md:mb-6 gap-3 sm:gap-0">
        <h2
          id="form-summary-title"
          className="text-xl md:text-2xl font-semibold text-pretty text-center sm:text-left"
        >
          Form Summary
        </h2>

        <div className="inline-flex items-center justify-center sm:justify-between rounded-md border border-[#000000] bg-card px-4 py-2 text-base w-full sm:w-auto">
          <span className="mr-2 font-medium">Total Points:</span>
          <span className="text-primary font-semibold text-[#005787]">
            {totalPoints}
          </span>
        </div>
      </div>

      <Card className="p-0 space-y-3 border-none shadow-none rounded-none">
        <div className="text-sm text-muted-foreground">
          Eligible for: <br />
          <span className="underline decoration-muted-foreground/40 underline-offset-2">
            189 Visa Stream
          </span>
          <span className="mx-2">→</span>
          <span
            className={`inline-flex items-center rounded-sm px-2.5 py-1 bg-transparent font-medium ${
              lessPoints ? "text-[#ef4444]" : "text-[#22c55e]"
            } border-[1px] border-[#000000]`}
          >
            {totalPoints
              ? lessPoints
                ? "65 Points"
                : `${totalPoints} Points`
              : "0 Points"}
          </span>
          <span className="ml-2 underline decoration-muted-foreground/40 underline-offset-2">
            190 Visa Stream
          </span>
          <span className="mx-2">→</span>
          <span
            className={`inline-flex items-center rounded-sm px-2.5 py-1 bg-transparent font-medium ${
              lessPoints ? "text-[#ef4444]" : "text-[#22c55e]"
            } border-[1px] border-[#000000]`}
          >
            {totalPoints
              ? lessPoints
                ? "70 Points"
                : `${totalPoints + 5} Points`
              : "0 Points"}
          </span>
          <span className="mx-2">&</span>
          <span className="underline decoration-muted-foreground/40 underline-offset-2">
            491 Visa Stream
          </span>
          <span className="mx-2">→</span>
          <span
            className={`inline-flex items-center rounded-sm px-2.5 py-1 bg-transparent font-medium ${
              lessPoints ? "text-[#ef4444]" : "text-[#22c55e]"
            } border-[1px] border-[#000000]`}
          >
            {totalPoints
              ? lessPoints
                ? "80 Points"
                : `${totalPoints + 15} Points`
              : "0 Points"}
          </span>
        </div>
      </Card>
    </section>
  );
}
